import { DISTRIBUIDOR } from 'utils/constants/reach_role';

/**
 * Does this shipment need an exposure scenario?
 *
 * The rule was written out by hand in fifteen places across six files:
 *
 *   shipment.reach_role !== DISTRIBUIDOR
 *     && shipment.direct_registers[0].exposure_scenario !== 'nao'
 *     && shipment.direct_registers[0].exposure_scenario !== 'na'
 *
 * A distributor never does. Anyone else does, unless their registration says
 * the CE is 'nao' or 'na'.
 *
 * Every one of those copies reads `direct_registers[0]` without checking
 * there is one, so a shipment with no registration at all throws instead of
 * answering. The answer for that case is not a guess: the one place
 * in the codebase that did check says so in a comment - "If there are no
 * registers is the equivalent to the empty exposure_scenario case which means should be in
 * the list" - so no registration reads as needing a scenario, the same as a
 * blank CE.
 *
 * ⚠️ Only the first registration is consulted, which is what all fifteen
 * copies did. Whether a shipment with several registrations should look past
 * the first is a question for the product owners, not a thing to change
 * silently while adding a guard.
 */
export const needsScenario = shipment => {
  if (!shipment || shipment.reach_role === DISTRIBUIDOR) {
    return false;
  }

  const registration = (shipment.direct_registers || [])[0];
  if (!registration) {
    return true;
  }

  return registration.exposure_scenario !== 'nao' && registration.exposure_scenario !== 'na';
};
